import * as Yup from "yup";
import { emailAdressValidator } from "../../../Utils/stringUtls";


const optionalString = Yup.string().optional();
const optionalArray = Yup.array().optional();

// const optionalEmail = Yup.string()
//     .optional()
//     .test("email", "Invalid email", (val) => {
//         if (!val) return true;
//         return emailAdressValidator(val);
//     });

const generalErrorMessage = "Field is required";

export const validationSchemarequiredDigitalWallet = Yup.object({
    of_dw_mobile_wallets: Yup.array()
        .optional(),
    of_dw_mobile_wallet_other: Yup.string().when("of_dw_mobile_wallets", {
        is: (wallets) => wallets.includes("others"),
        then: () =>
            Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
        otherwise: () => Yup.string().optional(),
    }),
    of_dw_card_holders: Yup.array().optional(),
    of_dw_live_agent: Yup.string().when("of_dw_card_holders", {
        is: (cardholders) => cardholders.includes("live-agent"),
        then: () =>
            Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
        otherwise: () => Yup.string().optional(),
    }),
    of_dw_live_agent_other: Yup.string().when("of_dw_live_agent", {
        is: (live_agent) => live_agent === "other",
        then: () =>
            Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
        otherwise: () => Yup.string().optional(),
    }),
    of_dw_email_authentication: Yup.string().when("of_dw_card_holders", {
        is: (cardholders) => cardholders.includes("via-email"),
        then: () =>
            Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
        otherwise: () => Yup.string().optional(),
    }),
    of_dw_email_authentication_other: Yup.string().when(
        "of_dw_email_authentication",
        {
            is: (authentication_method) => authentication_method === "other",
            then: () =>
                Yup.string()
                    .required(generalErrorMessage)
                    .min(1, generalErrorMessage),
            otherwise: () => Yup.string().optional(),
        },
    ),

    of_dw_provisioning_process: Yup.string()
        .optional(),
    of_dw_i2c_mobile_app_host: Yup.string()
        .optional(),
    of_dw_service_enable_via: Yup.string().when("of_dw_i2c_mobile_app_host", {
        is: (of_dw_i2c_mobile_app_host) => of_dw_i2c_mobile_app_host === "no",
        then: () =>
            Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
        otherwise: () => Yup.string().optional(),
    }),
});
export const validationSchemaDigitalWallet = Yup.object({

    of_dw_mobile_wallets: optionalArray,

    of_dw_mobile_wallet_other: Yup.string().test(
        "wallet-other",
        generalErrorMessage,
        function (val) {
            const wallets = this.parent.of_dw_mobile_wallets || [];
            if (wallets.includes("others")) {
                return !val || val.length > 0;
            }
            return true;
        }
    ),

    of_dw_card_holders: optionalArray,

    of_dw_live_agent: Yup.string().test(
        "live-agent",
        generalErrorMessage,
        function (val) {
            const holders = this.parent.of_dw_card_holders || [];
            if (holders.includes("live-agent")) {
                return !val || val.length > 0;
            }
            return true;
        }
    ),

    of_dw_live_agent_other: Yup.string().test(
        "live-agent-other",
        generalErrorMessage,
        function (val) {
            const agent = this.parent.of_dw_live_agent;
            if (agent === "other") {
                return !val || val.length > 0;
            }
            return true;
        }
    ),

    of_dw_email_authentication: Yup.string().test(
        "email-auth",
        generalErrorMessage,
        function (val) {
            const holders = this.parent.of_dw_card_holders || [];
            if (holders.includes("via-email")) {
                return !val || val.length > 0;
            }
            return true;
        }
    ),

    of_dw_email_authentication_other: Yup.string().test(
        "email-auth-other",
        generalErrorMessage,
        function (val) {
            const auth = this.parent.of_dw_email_authentication;
            if (auth === "other") {
                return !val || val.length > 0;
            }
            return true;
        }
    ),

    of_dw_provisioning_process: optionalString,
    of_dw_i2c_mobile_app_host: optionalString,
    of_dw_service_enable_via: optionalString,

});
export const validationSchemaRequiredSecureEcommerce = Yup.object({
    of_acs_enable_acs: Yup.string().required(generalErrorMessage),
    of_acs_acs_provider: Yup.string().when("of_acs_enable_acs", {
        is: (of_acs_enable_acs) =>
            of_acs_enable_acs && of_acs_enable_acs === "yes",
        then: () =>
            Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
        otherwise: () => Yup.string().optional(),
    }),
    of_acs_provider_other: Yup.string().when("of_acs_acs_provider", {
        is: (provider) => provider && provider === "other",
        then: () =>
            Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
        otherwise: () => Yup.string().optional(),
    }),
    of_acs_otp_services: Yup.array().optional(),
    of_acs_otp_service_other: Yup.string().when("of_acs_otp_services", {
        is: (otpServices) => otpServices && otpServices.includes("other"),
        then: () =>
            Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
        otherwise: () => Yup.string().optional(),
    }),
    of_acs_otp_service_provider: Yup.string()
        .required(generalErrorMessage)
        .min(1, generalErrorMessage),
    of_acs_otp_service_provider_other: Yup.string().when(
        "of_acs_otp_service_provider",
        {
            is: (serviceProvider) => serviceProvider && serviceProvider === "other",
            then: () =>
                Yup.string()
                    .required(generalErrorMessage)
                    .min(1, generalErrorMessage),
            otherwise: () => Yup.string().optional(),
        },
    ),
});
export const validationSchemaSecureEcommerce = Yup.object({

    of_acs_enable_acs: optionalString,

    of_acs_acs_provider: Yup.string().test(
        "acs-provider",
        generalErrorMessage,
        function (val) {
            const enable = this.parent.of_acs_enable_acs;
            if (enable === "yes") {
                return !val || val.length > 0;
            }
            return true;
        }
    ),

    of_acs_provider_other: Yup.string().test(
        "acs-provider-other",
        generalErrorMessage,
        function (val) {
            const provider = this.parent.of_acs_acs_provider;
            if (provider === "other") {
                return !val || val.length > 0;
            }
            return true;
        }
    ),

    of_acs_otp_services: optionalArray,

    of_acs_otp_service_other: Yup.string().test(
        "otp-service-other",
        generalErrorMessage,
        function (val) {
            const services = this.parent.of_acs_otp_services || [];
            if (services.includes("other")) {
                return !val || val.length > 0;
            }
            return true;
        }
    ),

    of_acs_otp_service_provider: optionalString,

    of_acs_otp_service_provider_other: Yup.string().test(
        "otp-provider-other",
        generalErrorMessage,
        function (val) {
            const provider = this.parent.of_acs_otp_service_provider;
            if (provider === "other") {
                return !val || val.length > 0;
            }
            return true;
        }
    ),

});
export const validationSchemaRequiredChargeBackAndDispute = Yup.object({
    of_cdp_processor: Yup.number().required(generalErrorMessage).nonNullable(),
    of_cdp_company_name: Yup.string().when("of_cdp_processor", {
        is: (service_type) => service_type === 2,
        then: () =>
            Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
        otherwise: () => Yup.string().optional(),
    }),
    of_cdp_contact_name: Yup.string().when("of_cdp_processor", {
        is: (service_type) => service_type === 2,
        then: () =>
            Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
        otherwise: () => Yup.string().optional(),
    }),
    of_cdp_job_title: Yup.string().when("of_cdp_processor", {
        is: (service_type) => service_type === 2,
        then: () =>
            Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
        otherwise: () => Yup.string().optional(),
    }),
    of_cdp_phone_number: Yup.string().when("of_cdp_processor", {
        is: (service_type) => service_type === 2,
        then: () =>
            Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
        otherwise: () => Yup.string().optional(),
    }),
    of_cdp_email: Yup.string().when("of_cdp_processor", {
        is: (service_type) => service_type === 2,
        then: () =>
            Yup.string()
                .required(generalErrorMessage)
                .min(1, generalErrorMessage)
                .test("", "", function (item) {
                    // this.parent gives the whole parent
                    return emailAdressValidator(item);
                }),
        otherwise: () => Yup.string().optional(),
    }),
});
export const validationSchemaChargeBackAndDispute = Yup.object({

    of_cdp_processor: Yup.number().nullable().optional(),

    of_cdp_company_name: Yup.string().test(
        "company-name",
        generalErrorMessage,
        function (val) {
            const processor = this.parent.of_cdp_processor;
            if (processor === 2) {
                return !val || val.length > 0;
            }
            return true;
        }
    ),

    of_cdp_contact_name: Yup.string().test(
        "contact-name",
        generalErrorMessage,
        function (val) {
            const processor = this.parent.of_cdp_processor;
            if (processor === 2) {
                return !val || val.length > 0;
            }
            return true;
        }
    ),

    of_cdp_job_title: Yup.string().test(
        "job-title",
        generalErrorMessage,
        function (val) {
            const processor = this.parent.of_cdp_processor;
            if (processor === 2) {
                return !val || val.length > 0;
            }
            return true;
        }
    ),

    of_cdp_phone_number: Yup.string().test(
        "phone-number",
        generalErrorMessage,
        function (val) {
            const processor = this.parent.of_cdp_processor;
            if (processor === 2) {
                return !val || val.length > 0;
            }
            return true;
        }
    ),

    of_cdp_email: Yup.string().test(
        "email",
        generalErrorMessage,
        function (val) {
            const processor = this.parent.of_cdp_processor;

            if (processor === 2) {
                if (!val) return true;
                return emailAdressValidator(val);
            }

            return !val || emailAdressValidator(val);
        }
    ),

});
export const validationSchemaRequiredProgramManagementService = Yup.object({
    of_pms_processor: Yup.number().required(generalErrorMessage).nonNullable(),
    of_pms_company_name: Yup.string().when("of_pms_processor", {
        is: (service_type) => service_type === 2,
        then: () =>
            Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
        otherwise: () => Yup.string().optional(),
    }),
    of_pms_contact_name: Yup.string().when("of_pms_processor", {
        is: (service_type) => service_type === 2,
        then: () =>
            Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
        otherwise: () => Yup.string().optional(),
    }),
    of_pms_job_title: Yup.string().when("of_pms_processor", {
        is: (service_type) => service_type === 2,
        then: () =>
            Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
        otherwise: () => Yup.string().optional(),
    }),
    of_pms_phone_number: Yup.string().when("of_pms_processor", {
        is: (service_type) => service_type === 2,
        then: () =>
            Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
        otherwise: () => Yup.string().optional(),
    }),
    of_pms_email: Yup.string().when("of_pms_processor", {
        is: (service_type) => service_type === 2,
        then: () =>
            Yup.string()
                .required(generalErrorMessage)
                .min(1, generalErrorMessage)
                .test("", "", function (item) {
                    // this.parent gives the whole parent
                    return emailAdressValidator(item);
                }),
        otherwise: () => Yup.string().optional(),
    }),
    
});
export const validationSchemaProgramManagementService = Yup.object({

    of_pms_processor: Yup.number().nullable().optional(),

    of_pms_company_name: Yup.string().test(
        "company-name",
        generalErrorMessage,
        function (val) {
            const processor = this.parent.of_pms_processor;
            if (processor === 2) {
                return !val || val.length > 0;
            }
            return true;
        }
    ),

    of_pms_contact_name: Yup.string().test(
        "contact-name",
        generalErrorMessage,
        function (val) {
            const processor = this.parent.of_pms_processor;
            if (processor === 2) {
                return !val || val.length > 0;
            }
            return true;
        }
    ),

    of_pms_job_title: Yup.string().test(
        "job-title",
        generalErrorMessage,
        function (val) {
            const processor = this.parent.of_pms_processor;
            if (processor === 2) {
                return !val || val.length > 0;
            }
            return true;
        }
    ),

    of_pms_phone_number: Yup.string().test(
        "phone",
        generalErrorMessage,
        function (val) {
            const processor = this.parent.of_pms_processor;
            if (processor === 2) {
                return !val || val.length > 0;
            }
            return true;
        }
    ),

    of_pms_email: Yup.string().test(
        "email",
        generalErrorMessage,
        function (val) {
            const processor = this.parent.of_pms_processor;

            if (processor === 2) {
                if (!val) return true;
                return emailAdressValidator(val);
            }

            return !val || emailAdressValidator(val);
        }
    ),
 

  

});
export const validationSchemaACHRequired = Yup.object({
    ov_ach_use_odfi: Yup.string()
        .required(generalErrorMessage)
        .min(1, generalErrorMessage),
    ov_ach_odfi: Yup.string().when("ov_ach_use_odfi", {
        is: (use_odfi) => use_odfi === "no",
        then: () =>
            Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
        otherwise: () => Yup.string().optional(),
    }),
    ov_ach_bank: Yup.string().when("ov_ach_use_odfi", {
        is: (use_odfi) => use_odfi === "no",
        then: () =>
            Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
        otherwise: () => Yup.string().optional(),
    }),
    ov_ach_account: Yup.string().when("ov_ach_use_odfi", {
        is: (use_odfi) => use_odfi === "no",
        then: () =>
            Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
        otherwise: () => Yup.string().optional(),
    }),
    ov_ach_routing: Yup.string().when("ov_ach_use_odfi", {
        is: (use_odfi) => use_odfi === "no",
        then: () =>
            Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
        otherwise: () => Yup.string().optional(),
    }),
});
export const validationSchemarequired = Yup.object({
    ov_mtm_service_code: Yup.string()
        .required(generalErrorMessage)
        .min(1, generalErrorMessage),
    ov_mtm_service_short_code: Yup.string().when("ov_mtm_service_code", {
        is: (code) => code && code === "dedicated-short-code",
        then: () =>
            Yup.string()
                .required("Dedicated short code is required")
                .min(1, "Dedicated short code other is required."),
        otherwise: () => Yup.string().optional(),
    }),
    ov_mtm_service_use: Yup.string().required(generalErrorMessage),
});
export const validationSchemaNightlyFiles = Yup.object({
    ov_nf_ssrp_for_manager: Yup.string()
        .required(generalErrorMessage)
        .min(0, generalErrorMessage),
    ov_nf_cut_off_time: Yup.string().optional(),
    ov_nf_pci_compliant: Yup.string()
        .required(generalErrorMessage)
        .min(1, generalErrorMessage),
    ov_nf_comp_cert: Yup.string().when("ov_nf_pci_compliant", {
        is: (code) => code && code === "yes",
        then: () =>
            Yup.string()
                .required("Please select a compliance certificate")
                .min(1, "Compliance certificate is required."),
        otherwise: () => Yup.string().optional(),
    }),
});
export const validationSchemaRequiredFraudManagement = Yup.object({
    of_fm_service_type: Yup.string()
        .required(generalErrorMessage)
        .min(1, generalErrorMessage),
    of_fm_company_name: Yup.string().when("of_fm_service_type", {
        is: (service_type) => service_type === "other",
        then: () =>
            Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
        otherwise: () => Yup.string().optional(),
    }),
    of_fm_contact_name: Yup.string().when("of_fm_service_type", {
        is: (service_type) => service_type === "other",
        then: () =>
            Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
        otherwise: () => Yup.string().optional(),
    }),
    of_fm_job_title: Yup.string().when("of_fm_service_type", {
        is: (service_type) => service_type === "other",
        then: () =>
            Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
        otherwise: () => Yup.string().optional(),
    }),
    of_fm_phone_number: Yup.string().when("of_fm_service_type", {
        is: (service_type) => service_type === "other",
        then: () =>
            Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
        otherwise: () => Yup.string().optional(),
    }),
    of_fm_email: Yup.string().when("of_fm_service_type", {
        is: (service_type) => service_type === "other",
        then: () =>
            Yup.string()
                .required(generalErrorMessage)
                .min(1, generalErrorMessage)
                .test("", "", function (item) {
                    // this.parent gives the whole parent
                    return emailAdressValidator(item);
                }),
        otherwise: () => Yup.string().optional(),
    }),
});
 

export const validationSchemaFraudManagement = Yup.object({

  of_fm_service_type: optionalString,

  of_fm_company_name: Yup.string().test(
    "company-name",
    generalErrorMessage,
    function (val) {
      const type = this.parent.of_fm_service_type;
      if (type === "other") {
        return !val || val.length > 0;
      }
      return true;
    }
  ),

  of_fm_contact_name: Yup.string().test(
    "contact-name",
    generalErrorMessage,
    function (val) {
      const type = this.parent.of_fm_service_type;
      if (type === "other") {
        return !val || val.length > 0;
      }
      return true;
    }
  ),

  of_fm_job_title: Yup.string().test(
    "job-title",
    generalErrorMessage,
    function (val) {
      const type = this.parent.of_fm_service_type;
      if (type === "other") {
        return !val || val.length > 0;
      }
      return true;
    }
  ),

  of_fm_phone_number: Yup.string().test(
    "phone",
    generalErrorMessage,
    function (val) {
      const type = this.parent.of_fm_service_type;
      if (type === "other") {
        return !val || val.length > 0;
      }
      return true;
    }
  ),

  of_fm_email: Yup.string().test(
    "email",
    generalErrorMessage,
    function (val) {
      const type = this.parent.of_fm_service_type;

      if (type === "other") {
        if (!val) return true;
        return emailAdressValidator(val);
      }

      return !val || emailAdressValidator(val);
    }
  ),

});
